import { Resource } from '@core';
import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';

import ChevronRightIcon from './assets/chevronRight.inline.svg';
import * as styles from './postMerchantBigCard.module.css';

interface Props extends StyleProps {
  merchant: Resource;
}

export const GuidesAndTipsMerchantBigCard: FC<Props> = ({ className, style = {}, merchant }) => {
  const { merchantName, webDescription, webLink, webImage } = merchant;
  return (
    <a
      className={mc(
        'flex flex-col md:flex-row items-center',
        'overflow-hidden',
        'pt-0',
        'rounded-[24px] shadow-md border border-grey-500/10',
        className,
      )}
      style={style}
      target="_blank"
      href={webLink}
    >
      <div
        className={mc(
          'w-full md:w-56 h-56 md:basis-56 shrink-0 grow-0',
          'md:rounded-[24px] border border-grey-500/20',
          'flex justify-center items-center',
        )}
      >
        <div
          className={mc('rounded-full w-[160px] h-[160px]', 'border border-grey-500/20', 'bg-white bg-no-repeat bg-center')}
          style={{ backgroundImage: webImage ? `url(${webImage.url})` : undefined, backgroundSize: '80%' }}
        />
      </div>
      <div className={mc('flex flex-col justify-center flex-1', 'px-8 py-6')}>
        <div>
          <h5 className={mc('mt-0 mb-0', 'text-3xl font-literata leading-tight font-medium text-ocean-blue')}>{merchantName}</h5>
          {!!webDescription && (
            <div className={mc('hidden md:block', 'mt-2', 'w-full')}>
              <div className={mc('font-raleway leading-normal font-medium text-ocean-blue', styles.description)}>
                {webDescription}
              </div>
            </div>
          )}
          {!!webDescription && (
            <p className={mc('md:hidden', 'mt-2', 'w-full', 'font-raleway leading-normal font-medium text-ocean-blue')}>
              {webDescription}
            </p>
          )}
          <div className={mc('flex flex-row-reverse', 'border-t', 'pt-5 mt-4')}>
            <span
              className={mc(
                'flex flex-row items-center',
                'fill-ocean-blue text-ocean-blue font-medium',
                'hover:text-accent-orange hover:fill-accent-orange',
              )}
            >
              <span className="block mr-2">Learn More</span>
              <ChevronRightIcon />
            </span>
          </div>
        </div>
      </div>
    </a>
  );
};

export default GuidesAndTipsMerchantBigCard;
